import React, { Component } from "react";
import { connect } from "react-redux";
class InvoicePriceSetting extends Component {
  constructor(props) {
    super(props);
    this.state = {
      selectedOption: "usePrice",
      initialOption: "usePrice",
      showSaveButton: false,
    };
  }
  componentDidMount() {
    const { invoice_price } = this.props;
    console.log("initialOption:-->", invoice_price);

    this.setState({
      initialOption: invoice_price,
      selectedOption: invoice_price,
    });
  }
  handleOptionChange = (event) => {
    this.setState({
      selectedOption: event.target.value,
      showSaveButton: event.target.value !== this.state.initialOption,
    });
  };

  handleSaveChanges = () => {
    // Handle changes on the server (keep it empty for now)
    this.setState({
      initialOption: this.state.selectedOption,
      showSaveButton: false,
    });
    if (this.props.updateSettings) {
      this.props.updateSettings({
        setting_name: "invoice_price",
        setting_value: this.state.selectedOption,
      });
    }
  };

  render() {
    const radioButtonsData = [
      { text: "عرض و استعمال السعر في الفواتير", value: "usePrice" },
      {
        text: "عدم عرض السعر و عدم استعماله في الفواتير ",
        value: "DontUsePrice",
      },
    ];

    return (
      <div className="container border-bottom p-2">
        <div className="   ">
          {radioButtonsData.map((radio) => (
            <div
              className="form-check d-flex align-items-center"
              key={radio.value}
            >
              <input
                className="form-check-input"
                type="radio"
                name="priceSetting"
                value={radio.value}
                checked={this.state.selectedOption === radio.value}
                onChange={this.handleOptionChange}
                style={{ fontSize: "12px" }}
                id={`radio-${radio.value}`}
              />
              <label
                htmlFor={`radio-${radio.value}`}
                className="form-check-label ms-2"
              >
                {radio.text}
              </label>
            </div>
          ))}
          <div className="d-flex justify-content-end">
            {this.state.showSaveButton && (
              <button
                className="btn btn-primary mt-3"
                onClick={this.handleSaveChanges}
              >
                حفظ التغييرات
              </button>
            )}
          </div>
        </div>
      </div>
    );
  }
}
const mapDispatchToProps = {};
const mapStateToProps = (state) => ({
  invoice_price: state.settingState.invoice_price,
});
export default connect(
  mapStateToProps,
  mapDispatchToProps
)(InvoicePriceSetting);
